<template>
  <Modal class="change-title-modal">
    <div class="modal-header">
      <h5><i class="fas fa-edit"></i> เปลี่ยนชื่อ</h5>
      <button
        class="btn-close"
        @click.stop="$emit('update:showChangeTitleModal', false)">
        <i class="fas fa-times"></i>
      </button>
    </div>
    <div class="modal-body">
      <input
        type="text"
        class="form-control"
        v-model="parallelTitle">
    </div>
    <div class="modal-footer">
      <button
        @click="setTitle"
        class="btn btn-primary">
        บันทึก
      </button>
    </div>
  </Modal>
</template>

<script>
import Modal from '@/components/Modal.vue';

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    showChangeTitleModal: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      parallelTitle: '',
    };
  },
  components: {
    Modal,
  },
  mounted() {
    this.copyTitle();
  },
  methods: {
    copyTitle() {
      if (this.title) {
        this.parallelTitle = this.title;
      }
    },
    setTitle() {
      this.$emit('update:title', this.parallelTitle);
      this.$emit('update:showChangeTitleModal', false);
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';

.btn-close {
  position: absolute;
  top: 16px;
  right: 10px;
  background: transparent;
  border: none;
  outline: none;
  transition: color 250ms ease;
  color: $gray-700;
  &:hover {
    color: $red;
  }
}
</style>
